/* eslint-disable i18next/no-literal-string -- css not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

export const alert = defineSlotRecipe({
  slots: ['root', 'title', 'description', 'indicator', 'content'],
  className: 'chakra-alert',

  base: {
    root: {
      width: 'full',
      display: 'flex',
      alignItems: 'flex-start',
      position: 'relative',
      borderRadius: 'none',
    },
    title: {
      fontWeight: 'bold',
      marginEnd: 1,
    },
    description: {
      display: 'inline',
    },
    indicator: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: '0',
      width: 5,
      height: 6,
      _icon: { boxSize: 'full' },
    },
    content: {
      display: 'flex',
      flex: '1',
      gap: '1',
    },
  },

  compoundVariants: [
    {
      status: 'warning',
      variant: 'subtle',
      css: {
        root: {
          background: 'yellow.50',
        },
      },
    },
    {
      status: 'success',
      variant: 'subtle',
      css: {
        root: {
          background: 'on-lime.50',
        },
      },
    },
  ],

  variants: {
    status: {
      info: {
        root: { colorPalette: 'blue' },
      },
      warning: {
        root: { colorPalette: 'orange' },
      },
      success: {
        root: { colorPalette: 'green' },
      },
      error: {
        root: { colorPalette: 'red' },
      },
      neutral: {
        root: { colorPalette: 'gray' },
      },
    },

    inline: {
      true: {
        content: {
          display: 'inline-flex',
          flexDirection: 'row',
          alignItems: 'center',
        },
      },
      false: {
        content: {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },

    variant: {
      subtle: {
        root: {
          bg: 'colorPalette.50',
          color: 'gray.fg',
        },
        indicator: {
          color: 'colorPalette.fg',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: '0',
          width: '1em',
          height: '1em',
          _icon: { boxSize: 'full' },
        },
      },
      surface: {
        root: {
          bg: 'colorPalette.subtle',
          color: 'colorPalette.fg',
          shadow: 'inset 0 0 0px 1px var(--shadow-color)',
          shadowColor: 'colorPalette.muted',
        },
        indicator: {
          color: 'colorPalette.fg',
        },
      },

      outline: {
        root: {
          color: 'colorPalette.fg',
          shadow: 'inset 0 0 0px 1px var(--shadow-color)',
          shadowColor: 'colorPalette.muted',
        },
        indicator: {
          color: 'colorPalette.fg',
        },
      },

      solid: {
        root: {
          bg: 'colorPalette.solid',
          color: 'colorPalette.contrast',
        },
        indicator: {
          color: 'colorPalette.contrast',
        },
      },
    },

    size: {
      sm: {
        root: {
          gap: '2',
          px: '3',
          py: '3',
          textStyle: 'xs',
        },
        indicator: {
          textStyle: 'lg',
        },
      },
      md: {
        root: {
          gap: '2',
          px: '4',
          py: '3',
          textStyle: 'sm',
        },
        indicator: {
          textStyle: '2xl',
        },
      },
      lg: {
        root: {
          gap: '2',
          px: '4',
          py: '3',
          textStyle: 'md',
        },
        indicator: {
          textStyle: '2xl',
          width: 6,
          height: 6,
        },
      },
    },
  },

  defaultVariants: {
    status: 'info',
    variant: 'subtle',
    size: 'lg',
    inline: true,
  },
});
